import './PrivacyPolicy.css';

const PrivacyPolicy = () => {

    return (

        <main className="privacy-page">

            <div className="privacy-wrap">
                <article className="privacy-card">

                    <div className="privacy-label">
                        개인정보 보호
                    </div>

                    <h1 className="privacy-title">
                        개인정보 처리방침
                    </h1>

                    <p className="privacy-updated">
                        시행일: 2025년 6월 24일
                    </p>

                    <section className="privacy-section">
                        <h2>1. 개인정보의 수집 항목 및 수집 방법</h2>
                        <p>회사는 회원가입 및 서비스 이용 과정에서 다음과 같은 개인정보를 수집합니다.</p>
                        <h3>수집 항목</h3>
                        <ul>
                            <li><strong>필수 항목:</strong> 이메일 주소, 비밀번호, 닉네임</li>
                            <li><strong>자동 수집 항목:</strong> 서비스 이용 기록, 접속 로그, 기기 정보(Android OS 버전, 기기 모델명)</li>
                            <li><strong>이미지 정보:</strong> 사용자가 서비스에 업로드하는 사진 이미지</li>
                        </ul>
                        <h3>수집 방법</h3>
                        <ul>
                            <li>회원가입 및 로그인 과정에서 사용자가 직접 입력</li>
                            <li>앱 사용 중 서비스 이용 기록 자동 수집</li>
                            <li>사용자가 이미지 업로드 기능을 통해 직접 제공</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>2. 개인정보의 수집 및 이용 목적</h2>
                        <p>회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다.</p>
                        <ul>
                            <li>회원 가입 및 관리: 회원身份 확인, 중복 가입 방지, 계정 관리</li>
                            <li>서비스 제공: 콘텐츠 게시 및 댓글 작성, 이미지 업로드 등 기능 제공</li>
                            <li>서비스 개선 및 분석: 사용자 이용 패턴 분석, 서비스 품질 개선</li>
                            <li>고객 지원: 문의 응대 및 오류 해결</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>3. 개인정보의 보유 및 파기</h2>
                        <p>회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 지체 없이 해당 정보를 파기합니다.</p>
                        <ul>
                            <li><strong>회원 계정 정보:</strong> 회원 탈퇴 시 즉시 파기</li>
                            <li><strong>게시글 및 댓글:</strong> 회원 탈퇴 시 해당 계정으로 작성된 게시글은 익명 처리되며, 댓글은 익명 처리되거나 삭제됩니다.</li>
                            <li><strong>이용 기록:</strong> 수집일로부터 최대 1년간 보관 후 파기</li>
                            <li><strong>관계 법령에 따른 보관:</strong> 전자상거래법 등 관련 법령에 따라 일부 정보는 일정 기간 보관 후 파기</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>4. 개인정보의 제3자 제공</h2>
                        <p>회사는 원칙적으로 사용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                        <ul>
                            <li>사용자가 사전에 동의한 경우</li>
                            <li>법령에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 요청이 있는 경우</li>
                        </ul>
                        <h3>외부 서비스 이용</h3>
                        <p>서비스 이용 과정에서 다음과 같은 외부 서비스를 사용하며, 해당 서비스의 개인정보 처리 정책이 적용됩니다.</p>
                        <ul>
                            <li><strong>Cloudinary (cloudinary.com):</strong> 이미지 업로드 및 호스팅 — 사용자가 업로드한 이미지는 Cloudinary 서버에 저장됩니다.</li>
                            <li><strong>YouTube (youtube.com):</strong> 동영상 콘텐츠 제공 — YouTube API를 통해 영상 정보를 표시합니다.</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>5. 사용자의 권리</h2>
                        <p>사용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.</p>
                        <ul>
                            <li>개인정보 열람 요구</li>
                            <li>개인정보 정정 요구</li>
                            <li>개인정보 삭제 요구 (회원 탈퇴)</li>
                            <li>개인정보 처리 정지 요구</li>
                        </ul>
                        <p>권리 행사는 앱 내 설정 메뉴 또는 아래 연락처를 통해 요청할 수 있으며, 회사는 지체 없이 조치하겠습니다.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>6. 개인정보의 안전성 확보 조치</h2>
                        <p>회사는 사용자의 개인정보를 안전하게 보호하기 위해 다음과 같은 조치를 취하고 있습니다.</p>
                        <ul>
                            <li>비밀번호는 BCrypt 암호화 방식으로 안전하게 저장됩니다.</li>
                            <li>JWT 토큰 기반 인증을 통해 사용자 인증 정보를 보호합니다.</li>
                            <li>SSL/TLS 암호화 통신을 통해 데이터 전송 구간을 보호합니다.</li>
                            <li>서버 접근 권한을 최소 인원으로 제한하고 정기적으로 감사합니다.</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>7. 아동의 개인정보 보호</h2>
                        <p>본 서비스는 만 14세 이상의 사용자를 대상으로 하며, 만 14세 미만 아동의 개인정보를 의도적으로 수집하지 않습니다. 만 14세 미만 아동이 회원가입을 시도하는 경우 계정이 삭제될 수 있습니다.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>8. 개인정보 처리방침 변경</h2>
                        <p>본 개인정보 처리방침은 법령 정책 또는 서비스의 변경에 따라 개정될 수 있습니다. 개정 시 앱 내 공지사항을 통해 사전 안내드리며, 변경 사항은 공지 후 7일 이후에 효력이 발생합니다.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>9. 문의처</h2>
                        <p>개인정보 처리와 관련하여 문의사항이 있으신 경우 아래 연락처로 문의해 주십시오.</p>
                        <ul>
                            <li><strong>이메일:</strong> wearsohn@gmail.com</li>
                            <li><strong>담당자:</strong> 개인정보 보호 책임자</li>
                        </ul>
                    </section>

                    <div className="privacy-footer">
                        <p>본 개인정보 처리방침은 2025년 6월 24일부터 적용됩니다.</p>
                    </div>

                </article>

            </div>

        </main>
    );
};

export default PrivacyPolicy;
